import type { TabId } from '../types';
interface Props {
  currentTab: TabId;
  onSwitch: (id: TabId) => void;
}
const TABS: {
  id: TabId;
  dot: string;
  title: string;
  sub: string;
}[] = [{
  id: 'vp',
  dot: '#fa0f00',
  title: 'VP / Leadership',
  sub: 'Global impact, delivery & performance'
}, {
  id: 'sd',
  dot: '#a78bfa',
  title: 'SC Leaders (SD)',
  sub: 'Coverage heatmap & shift opportunity'
}, {
  id: 'od',
  dot: '#34d399',
  title: 'OnDemand Team',
  sub: 'Capacity, aging & where the team is pulled'
}, {
  id: 'at',
  dot: '#f59e0b',
  title: 'Availability Tracker',
  sub: 'Capacity management & resource planning'
}];
export function TabNav({
  currentTab,
  onSwitch
}: Props) {
  return <div className="bg-[#253044] flex" data-id="element-893" data-mp="1l1hu928v6j16">
      {TABS.map(tab => <button key={tab.id} onClick={() => onSwitch(tab.id)} className={['px-[18px] py-3 cursor-pointer border-r border-r-white/[0.08] last:border-r-0 flex-1 transition-colors border-b-2 text-left', currentTab === tab.id ? 'bg-[#2e3d58] border-b-[#4f9cf9]' : 'border-b-transparent hover:bg-[#2a3650]'].join(' ')} data-id="element-894" data-mp="1g1vdiittuknm">
          <div className="text-[12px] font-medium text-white mb-[2px] flex items-center gap-[6px]" data-id="element-895" data-mp="24fmy3g8nbxqh">
            <span className="w-[7px] h-[7px] rounded-full flex-shrink-0" style={{
          background: tab.dot
        }} data-id="element-896" data-mp="1qk1drmdcy24e" />
            {tab.title}
          </div>
          <div className="text-[10px] text-white/40" data-id="element-897" data-mp="2j641v68r6zqj">{tab.sub}</div>
        </button>)}
    </div>;
}